import * as types from './actionTypes';
import { getRequest, postRequest, putRequest, deleteRequest } from '../../lib/apiUtils';

export function getAllCampaignLists() {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGN_LISTS });

        const response = await getRequest(`/campaignLists`);
        response.data = response.data.records ? response.data.records.map(list => ({
            key: list.campaignListId,
            value: list.name,
            ...list
        })) : [];

        dispatch({ type: types.GET_CAMPAIGN_LISTS, response });
    };
}

export function updateCampaignListsSearch(keyword) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGN_LISTS_SEARCH, keyword });
    }
}

export function updateTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGN_LISTS_TABLE, settings });
    }
}

export function getCampaignLists(page = 1, results = 12, sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_CAMPAIGN_LISTS_TABLE, settings });

        const requestId = ++getState().campaignListsTable.currentRequestId;
        dispatch({ type: types.START_GET_CAMPAIGN_LISTS_TABLE_RECORDS, requestId });

        const tableSettings = getState().campaignListsTable;
        const keyword = getState().campaignLists.keyword;
        const params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView,
            keyword
        };

        const response = await getRequest('/campaignLists', params);

        dispatch({ type: types.GET_CAMPAIGN_LISTS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function createCampaignList(campaignList) {
    return async dispatch => {
        dispatch({ type: types.START_CREATE_CAMPAIGN_LIST });

        const response = await postRequest("/campaignLists", campaignList);

        dispatch({ type: types.CREATE_CAMPAIGN_LIST, response });

        if (response.success) {
            dispatch(getAllCampaignLists());
        }
    };
}

export function getCampaignListDetails(campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGN_LIST_DETAILS });

        const response = await getRequest(`/campaignLists/${campaignListId}`);

        dispatch({ type: types.GET_CAMPAIGN_LIST_DETAILS, response });
    };
}

export function clearCampaignListDetails() {
    return dispatch => {
        dispatch({ type: types.CLEAR_CAMPAIGN_LIST_DETAILS });
        dispatch({ type: types.CLEAR_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS });
    };
}

export function updateCampaignList(campaignList) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_CAMPAIGN_LIST_DETAILS });

        const { allowDuplicates, campaignListId, managerName, managerEmail, fundId, locationId, campaignListType } = campaignList;
        const response = await putRequest(`/campaignLists/${campaignListId}`, { allowDuplicates, managerName, managerEmail, fundId, locationId, campaignListType });

        if (response.success) {
            const updatedCampaignList = await getRequest(`/campaignLists/${campaignListId}`);
            response.data = updatedCampaignList.data;
        }

        dispatch({ type: types.UPDATE_CAMPAIGN_LIST_DETAILS, response });

        if (response.success) {
            dispatch(getAllCampaignLists());
        }
    };
}

export function getCampaignListAllParticipants(campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS });

        const response = await getRequest(`/campaignLists/${campaignListId}/participants`);
        response.data = response.data ? response.data.records || [] : [];

        dispatch({ type: types.GET_CAMPAIGN_LIST_ALL_PARTICIPANTS, response });
    };
}

export function updateParticipantsTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE, settings });
    };
}

export function getCampaignListParticipants(campaignListId, page = 1, results = 12, sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE, settings });

        const requestId = ++getState().campaignListParticipantsTable.currentRequestId;
        dispatch({ type: types.START_GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS, requestId });

        const tableSettings = getState().campaignListParticipantsTable;
        let params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView
        };

        const response = await getRequest(`/campaignLists/${campaignListId}/participants`, params);

        dispatch({ type: types.GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function removeCampaignListParticipant(campaignListId, participantId, bypassError, removeFromActiveCampaign) {
    return async dispatch => {
        dispatch({ type: types.START_REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD, recordId: campaignListId });

        const response = await deleteRequest(`/campaignLists/${campaignListId}/participants/${participantId}`,
            { bypassError, removeFromActiveCampaign });
        response.recordIdKey = "applicantId";
        response.recordId = participantId;

        dispatch({ type: types.REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD, response });
    }
}

export function addCampaignListParticipants(campaignListId, recipientIds, bypassError, addToActiveCampaign, getUpdatedListDetails) {
    return async dispatch => {
        dispatch({ type: types.START_ADD_CAMPAIGN_LIST_PARTICIPANT });

        const response = await postRequest(`/campaignLists/${campaignListId}/participants?bypassError=${bypassError}`, { recipientIds, addToActiveCampaign });

        dispatch({ type: types.ADD_CAMPAIGN_LIST_PARTICIPANT, response });

        if (getUpdatedListDetails && response.success) {
            const updatedCampaignList = await getRequest(`/campaignLists/${campaignListId}`);
            response.data = updatedCampaignList.data;

            dispatch({ type: types.UPDATE_CAMPAIGN_LIST_DETAILS, response });
        }
    };
}

export function getCampaignListPendingParticipants(campaignListId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS });

        const response = await getRequest(`/campaignLists/${campaignListId}/pendingParticipants`);

        dispatch({ type: types.GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS, response });
    };
}


// WEBPACK FOOTER //
// ./src/redux/actions/CampaignListsActions.js